// @ts-nocheck
import { Menu } from '@headlessui/react';
import React from 'react';

interface ChildProps {
  focused: boolean;
  disabled: boolean;
}

interface Props extends Record<string, any> {
  children: (props: ChildProps) => JSX.Element;
  disabled?: boolean;
  as?: React.ElementType<any> | JSX.Element;
}

/**
 * @see Doc https://headlessui.dev/react/menu#menu-item
 */
const DropdownItem: React.FC<Props> = ({
  children,
  disabled = false,
  as = React.Fragment,
  ...rest
}) => {
  return (
    <Menu.Item as={as} disabled={disabled} {...rest}>
      {({ active, disabled }) => children({ focused: active, disabled })}
    </Menu.Item>
  );
};

export default DropdownItem;
